<template>
  <base-material-card
    color="primary"
    icon="mdi-broom"
    inline
    class="px-5 py-4 ml-0"
  >
    <template v-slot:after-heading>
      <div class="display-2 font-weight-light">
        {{ title }}
      </div>
    </template>
    <v-form class="mt-5">
      <v-row align="center" class="mx-auto">
        <v-col cols="12">
          <validation-provider v-slot="{ errors }" rules="required" id="titulo-cmu">
            <v-text-field
              label="Título"
              outlined
              :error-messages="errors"
              v-model="nome"
            />
          </validation-provider>
        </v-col>
      </v-row>

      <v-row class="mx-auto">
        <v-col cols="12">
          <v-radio-group v-model="origem" mandatory :column="false" class="mt-0">
            <v-radio label="Preencher Manualmente" value="manual" class="mr-6"/>
            <v-radio label="Arquivo .CSV" value="arquivo" />
          </v-radio-group>
        </v-col>
      </v-row>

      <v-row align="center" class="mx-auto" v-if="origem == 'arquivo'">
        <v-col cols="12" class="py-0" id="cmu-v-alert">
          <v-alert dense outlined type="info" color="blue" class="pa-2">
            <a href="javascript:void(0)" @click="getArquivoPadrao()">Clique aqui</a> para exportar os valores atuais do sistema. Edite os custos, salve como CSV e envie o arquivo.
            <br>O arquivo deve conter <b>apenas</b> as colunas: <b>Sigla ANEEL</b>, <b>Tipologia</b>, <b>Ano</b> e <b>Custo Médio</b>.
          </v-alert>
        </v-col>
      </v-row>

      <div id="cmu-campos-arquivo" v-if="origem == 'arquivo'">
        <v-row align="center" class="mx-auto">
          <v-col cols="12" class="pl-2">
            <validation-provider v-slot="{ errors }" rules="required">
              <v-file-input
                @change="uploadNewFile()"
                label="Arquivo CSV"
                placeholder="Selecione um arquivo CSV"
                outlined
                accept=".csv, .zip"
                v-model="arquivo.fileObj"
                truncate-length="30"
                :loading="arquivo.uploading"
                loader-height="4"
                :success="arquivo.id && arquivo.fileObj ? true : false"
                :error-messages="errors"
              />
            </validation-provider>

            <validation-provider rules="required">
              <input type="hidden" name="validate-upload-cmu" :value="arquivo.id" />
            </validation-provider>
          </v-col>
        </v-row>

        <parametros-arquivo-csv 
          :delimitador.sync="arquivo.delimitador"
          :involucro.sync="arquivo.involucro"
          :escape.sync="arquivo.escape"
        />
      </div>

      <v-row class="mx-auto" v-if="origem == 'manual'">
        <v-col cols="12">
          <v-data-table
            :headers="[
              {text: 'Sigla Aneel', value: 'sigla_aneel'},
              {text: 'Tipologia Aneel', value: 'tipologia'},
              {text: 'Ano', value: 'ano'},
              {text: 'Custo Médio', value: 'custo', width: '80px'}
            ]"
            :items="valores"
            dense
            hide-default-footer
            disable-pagination
            disable-filtering
            disable-sort
            mobile-breakpoint="760"
          >
            <template v-slot:[`item.sigla_aneel`]="{ item }">
              {{ item.sigla_aneel | ChfusCom | PrCom }}
            </template>
            <template v-slot:[`item.custo`]="{ item }">
              <v-text-field
                v-model="item.custo"
                min="0" type="number" step="0.001"
                @blur="(item.custo < 0) ? item.custo = 0 : 1"
                hide-details class="my-0 py-0"
              /> 
            </template>
          </v-data-table>
        </v-col>
      </v-row>
    </v-form>
  </base-material-card>
</template>

<script>

import ArquivosService from "@/services/ArquivosService.js";
import ConfiguracoesService from "@/services/ConfiguracoesService.js";
import CmuService from "@/services/parametrosComCa/CmuService";
import dayjs from "dayjs";

export default {
  name: "ParametrosCMU",

  components: {
    ParametrosArquivoCsv: () => import("@/components/general/GeneralParametrosArquivoCsv.vue"),
  },

  data() {
    return {
      nome: "",
      origem: "manual",
      valores: [],
      arquivo: {
        fileObj: undefined,
        id: "",
        delimitador: `;`,
        involucro: `"`,
        escape: `"`,
        uploading: false
      },
    }
  },

  computed: {
    user() {
      return this.$store.getters.getUser;
    },
    title() {
      return this.$route.params.id ? "Editando CMU" : "Adicionando CMU";
    },
  },

  mounted() {
    if(!this.$route.params.id) {
      this.getCsvCamposPadroes();
      this.getValoresPadroes();
    } else {
      this.getCMU(this.$route.params.id);
    }
  },

  methods: {
    getCsvCamposPadroes() {
      ConfiguracoesService.getCsvCamposPadroes()
        .then(response => {
          this.arquivo.delimitador = response.data.campos.delimitador.valor;
          this.arquivo.involucro = response.data.campos.involucro.valor;
          this.arquivo.escape = response.data.campos.escape.valor;
        })
        .catch(err => {
          console.error(err);
          this.$toast.error("Erro ao recuperar campos padrões do arquivo csv.", "", { position: "topRight" });
        });
    },
    getValoresPadroes() {
      CmuService.getValoresPadroes()
        .then((res) => {
          this.valores = res.data.valoresPadrao;
        })
        .catch(error => {
          console.error(error);
          this.$toast.error('Erro ao recuperar valores padrões do sistema.', '', { position:'topRight' });
        })
    },
    uploadNewFile() {
      if (!this.arquivo.fileObj) return;

      this.arquivo.id = "";
      this.arquivo.uploading = true;

      let data = new FormData();
      data.append("file", this.arquivo.fileObj);

      ArquivosService.uploadFile(data)
        .then(response => {
          this.arquivo.id = response.data.arquivoId;
        })
        .catch(err => {
          console.error("Erro ao fazer upload: ", err);
          if(err?.data?.cod_erro == 10000){
            let msg = "Há mais de um arquido dentro do ZIP.<br>Adicione apenas um arquivo CSV.";
            this.$toast.error(msg,  "", { position: "topRight", timeout: 8000 });
          }else{
            this.$toast.error("Erro no upload do arquivo.", "", { position: "topRight" });
          }

          this.arquivo.fileObj = undefined;
        })
        .finally(() => this.arquivo.uploading = false);
    },
    getCMU(id) {
      CmuService.getValoresUnitarios(id)
        .then((res) => {
          this.nome = res.data.valores.nome;
          let jsonValores = JSON.parse(res.data.valores.json);
          this.valores = [];
          
          Object.keys(jsonValores).forEach(sigla_aneel => {
            for (const tipologia in jsonValores[sigla_aneel]) {
              for (const ano in jsonValores[sigla_aneel][tipologia]) {
                this.valores.push({
                  id: this.valores.length + 1,
                  sigla_aneel: sigla_aneel,
                  tipologia: tipologia,
                  ano: ano,
                  custo: jsonValores[sigla_aneel][tipologia][ano]
                });
              }
            }
          });
        }).catch((err) => {
          console.error(err);
          this.$toast.error('Erro ao recuperar Normas Técnicas.', '', { position:'topRight' });
        });
    },
    getArquivoPadrao() {
      this.$toast.info("Processando...", "", { position: "topRight", timeout: 1250 });

      CmuService.getArquivoPadrao()
        .then(async res => {
          const url = window.URL.createObjectURL(new Blob([res.data]));
          const link = document.createElement("a");
          link.href = url;

          link.setAttribute("download", `CMU ${dayjs().format("YYYYMMDDHHmmss")}.xlsx`);
          document.body.appendChild(link);
          link.click();
        })
        .catch(err => {
          this.$toast.error("Erro ao baixar arquivo padrão do sistema", "", { position: "topRight"});
          console.error(err);
        })
    },
  },

  filters: {
    ChfusCom(str) {
      return str.toUpperCase() == "CHFUS" ? `${str}_COM` : str;
    },
    PrCom(str) {
      return str.toUpperCase() == "PR" ? `${str}_COM` : str;
    },
  }
}
</script>

<style>

</style>